import { Trans, t } from '@lingui/macro'
import classNames from 'classnames'
import React, { Component, ReactNode } from 'react'
import { Box, Flex } from '@chakra-ui/react'

import {
  PathwayEnrolmentModel,
  PathwayEnrolmentStatusEnum
} from 'front-end/src/graphql/private/PrivateSchemaTypes'

import CircleProgress from '../../../../components/common/circle-progress/CircleProgress'
import './PathwayProgressDetail.less'
import { dayjsFromNow } from 'shared/dayjs'
import { NbSp } from '../../../../utils/NbSp'
import { formatDateAndTimeShort } from '../../../../utils/dateHelpers'
import { Tooltip } from 'front-end/src/components'

// TODO change the interface to get an IPathway after we unify shapes of a response as in pathwayDetailQuery
interface IProps {
  enrolment: PathwayEnrolmentModel
  showVersion?: boolean
}

export default class PathwayProgressDetail extends Component<IProps> {
  render(): ReactNode {
    const { enrolment, showVersion = false } = this.props

    if (!enrolment) {
      return null
    }

    const progressClasses = classNames('PathwayProgressDetail', {
      PathwayProgressDetail__notstarted:
        enrolment.status === PathwayEnrolmentStatusEnum.NOT_STARTED,
      PathwayProgressDetail__inprogress:
        enrolment.status === PathwayEnrolmentStatusEnum.IN_PROGRESS,
      PathwayProgressDetail__completed:
        enrolment.status === PathwayEnrolmentStatusEnum.COMPLETED,
      PathwayProgressDetail__failed:
        enrolment.status === PathwayEnrolmentStatusEnum.FAILED ||
        enrolment.status === PathwayEnrolmentStatusEnum.OVERDUE
    })

    let lineColor = '#00BB77'
    const stateName = (enrolment) => {
      switch (enrolment.status) {
        case PathwayEnrolmentStatusEnum.FAILED:
          lineColor = '#EF6969'
          return t`Pathway failed`
        case PathwayEnrolmentStatusEnum.COMPLETED:
          return t`Pathway complete`
        case PathwayEnrolmentStatusEnum.IN_PROGRESS:
          lineColor = '#5592e2'
          return t`In progress`
        case PathwayEnrolmentStatusEnum.NOT_STARTED:
          return t`Not started`
        case PathwayEnrolmentStatusEnum.OVERDUE:
          lineColor = '#EF6969'
          return t`Overdue`
      }
    }

    return (
      <div className={progressClasses}>
        <div className="PathwayProgressDetail__text">
          <Flex direction="column">
            <h3>{stateName(enrolment)}</h3>
            <Box mt="4px" mb="4px">
              {enrolment.completed_at && (
                <p>
                  <Trans>Completed</Trans>{' '}
                  {showVersion && (
                    <Box
                      as="span"
                      _after={{ content: '" • "' }}
                      data-test="CompletedVersion"
                    >
                      <Trans>version</Trans> {enrolment.pathwayVersion?.version}
                    </Box>
                  )}
                  <NbSp />
                  <Tooltip
                    text={formatDateAndTimeShort(enrolment.completed_at)}
                  >
                    <Box as="span" whiteSpace="nowrap">
                      {dayjsFromNow(enrolment.completed_at)}
                    </Box>
                  </Tooltip>
                </p>
              )}
              {enrolment.importedAt && (
                <p>
                  <Trans>Imported</Trans>{' '}
                  <Tooltip text={formatDateAndTimeShort(enrolment.importedAt)}>
                    {dayjsFromNow(enrolment.importedAt)}
                  </Tooltip>
                </p>
              )}
            </Box>
          </Flex>
        </div>
        <CircleProgress
          progress={(enrolment.progress || 0) / 100}
          lineWidth={8}
          lineColor={lineColor}
          backgroundLineColor="#e3e8e9"
          failed={enrolment.status === PathwayEnrolmentStatusEnum.FAILED}
          completed={enrolment.status === PathwayEnrolmentStatusEnum.COMPLETED}
        >
          <b>
            {enrolment.progress ? Math.round(enrolment.progress) : 0}
            <em>%</em>
          </b>
        </CircleProgress>
      </div>
    )
  }
}
